<!-- Loading -->
@if (isLoading()) {
  <div class="flex items-center justify-center min-h-screen" style="background:#fafaf7">
    <div class="relative w-10 h-10">
      <div class="absolute inset-0 rounded-full border-4 border-stone-200"></div>
      <div class="absolute inset-0 rounded-full border-4 border-t-primary-400 animate-spin"></div>
    </div>
  </div>
}

@if (!isLoading()) {
  <div class="min-h-screen" style="background:#fafaf7">
    <div class="max-w-[1200px] mx-auto px-5 sm:px-8 py-8 space-y-5">

      <!-- Header -->
      <div class="fiche-titlebar grid grid-cols-3 items-center pt-0 px-0">
        <div class="justify-self-start">
          <button (click)="isEditMode() ? router.navigate(['/federation/mediatique', albumId]) : onBack()"
            class="flex items-center gap-2 text-stone-400 hover:text-primary-600 transition-colors cursor-pointer">
            <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7"/>
            </svg>
            <span class="text-[11px] font-bold uppercase tracking-wider">{{ isEditMode() ? 'Retour à l\'album' : 'Retour aux albums' }}</span>
          </button>
        </div>
        <div class="justify-self-center">
          <h1 class="page-title">{{ isEditMode() ? 'Modifier l\'album' : 'Album' }}</h1>
        </div>
        @if (!isEditMode()) {
          <div class="justify-self-end flex items-center gap-2">
            @if (permService.can('marketing', 'albums', 'edit')) {
              <button (click)="onEdit()" [disabled]="isSaving()"
                class="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium border border-stone-200 text-stone-600 bg-white hover:bg-stone-50 rounded-lg transition-colors disabled:opacity-50">
                <svg class="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931z"/>
                </svg>
                Modifier
              </button>
            }
            @if (permService.can('marketing', 'albums', 'delete')) {
              <button (click)="confirmDelete()" [disabled]="isSaving()"
                class="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium border border-stone-200 text-stone-500 bg-white hover:bg-stone-50 rounded-lg transition-colors disabled:opacity-50">
                <svg class="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M20.25 7.5l-.625 10.632a2.25 2.25 0 01-2.247 2.118H6.622a2.25 2.25 0 01-2.247-2.118L3.75 7.5M10 11.25h4M3.375 7.5h17.25c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125z"/>
                </svg>
                Archiver
              </button>
            }
          </div>
        } @else {
          <div class="justify-self-end"></div>
        }
      </div>

      @if (errorMessage()) {
        <div class="p-4 rounded-2xl bg-red-50 border border-red-100 text-sm text-red-700">{{ errorMessage() }}</div>
      }

      @if (album()) {

        <!-- Main card -->
        <div class="bg-white rounded-2xl border border-stone-100 shadow-sm overflow-hidden">

          <!-- Card header -->
          <div class="px-4 sm:px-6 py-4 border-b border-stone-100 flex items-center gap-3 sm:gap-4 flex-wrap">
            <div class="w-10 h-10 rounded-xl overflow-hidden bg-stone-100 flex-shrink-0 flex items-center justify-center relative">
              @if (coverPhoto) {
                <img [src]="coverPhoto" aria-hidden="true" class="absolute inset-0 w-full h-full object-cover blur-sm scale-110 opacity-60" />
                <img [src]="coverPhoto" alt="" class="relative z-10 h-full w-auto object-contain" />
              } @else {
                <span class="material-icons text-stone-300 text-lg">photo_library</span>
              }
            </div>
            <div>
              <h1 class="text-sm font-bold text-stone-800">{{ album()!.title }}</h1>
              <p class="text-[11px] text-stone-400 mt-0.5">
                @if (album()!.event_date) { {{ formatDate(album()!.event_date) }} · }
                {{ imageMedia.length }} photo{{ imageMedia.length > 1 ? 's' : '' }}
                @if (localMedia().length - imageMedia.length > 0) { · {{ localMedia().length - imageMedia.length }} vidéo{{ localMedia().length - imageMedia.length > 1 ? 's' : '' }} }
              </p>
            </div>
          </div>

          <!-- Section 1 — Info -->
          <div class="px-6 py-5 space-y-4">
            <p class="text-[10px] font-bold text-stone-400 uppercase tracking-widest">Informations</p>

            @if (isEditMode()) {
              <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div class="space-y-1.5">
                  <label class="text-[11px] font-semibold text-stone-500">Titre</label>
                  <input type="text"
                    [value]="editTitle()"
                    (input)="editTitle.set($any($event.target).value)"
                    class="fiche-input w-full"
                    placeholder="Titre de l'album"
                    autoDir />
                </div>
                <div class="space-y-1.5">
                  <label class="text-[11px] font-semibold text-stone-500">Date de l'événement</label>
                  <input type="date"
                    [value]="editDate()"
                    (input)="editDate.set($any($event.target).value)"
                    class="fiche-input w-full" />
                </div>
              </div>

              <div class="space-y-1.5">
                <label class="text-[11px] font-semibold text-stone-500">Tags</label>
                <app-tag-input module="MEDIA" [value]="editCategory()" (valueChange)="editCategory.set($event)"></app-tag-input>
              </div>

              <div class="space-y-1.5">
                <label class="text-[11px] font-semibold text-stone-500">Statut</label>
                <div class="flex items-center gap-3">
                  <label class="status-radio-label" [class.active]="editStatus() === 'ACTI'">
                    <input type="radio" name="edit_status" value="ACTI"
                      [checked]="editStatus() === 'ACTI'"
                      (change)="editStatus.set('ACTI')" class="hidden" />
                    <span class="w-2 h-2 rounded-full" [class]="editStatus() === 'ACTI' ? 'bg-emerald-500' : 'bg-stone-300'"></span>
                    En ligne
                  </label>
                  <label class="status-radio-label" [class.active-inac]="editStatus() === 'INAC'">
                    <input type="radio" name="edit_status" value="INAC"
                      [checked]="editStatus() === 'INAC'"
                      (change)="editStatus.set('INAC')" class="hidden" />
                    <span class="w-2 h-2 rounded-full" [class]="editStatus() === 'INAC' ? 'bg-amber-400' : 'bg-stone-300'"></span>
                    Hors ligne
                  </label>
                </div>
              </div>
            } @else {
              <div class="flex flex-wrap items-center gap-4 text-xs text-stone-500">
                @if (album()!.event_date) {
                  <span class="flex items-center gap-1">
                    <svg class="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5"/>
                    </svg>
                    {{ formatDate(album()!.event_date) }}
                  </span>
                }
                <app-tag-chips [value]="album()!.media_tags" [max]="999"></app-tag-chips>
                <span class="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full border font-medium"
                  [class]="album()!.status === 'ACTI' ? 'bg-emerald-50 text-emerald-600 border-emerald-100' : 'bg-amber-50 text-amber-600 border-amber-100'">
                  <span class="w-1.5 h-1.5 rounded-full flex-shrink-0"
                    [class]="album()!.status === 'ACTI' ? 'bg-emerald-500' : 'bg-amber-400'"></span>
                  {{ album()!.status === 'ACTI' ? 'En ligne' : 'Hors ligne' }}
                </span>
              </div>
            }
          </div>


          <!-- Section 2 — Média -->
          <div class="px-6 py-5 space-y-4">
            <p class="text-[10px] font-bold text-stone-400 uppercase tracking-widest">Média</p>

            <div class="photo-grid">

              <!-- All saved media items (images + videos mixed) -->
              @for (item of localMedia(); track item.id; let i = $index) {
                <div class="photo-cell"
                  [class.photo-main]="item.is_main"
                  [class.drag-over]="isEditMode() && dragOverIndex() === i && dragIndex() !== i"
                  [class.dragging]="isEditMode() && dragIndex() === i"
                  [draggable]="isEditMode()"
                  (dragstart)="isEditMode() && onDragStart(i)"
                  (dragover)="isEditMode() && onDragOver($event, i)"
                  (dragend)="isEditMode() && onDragEnd()">

                  <!-- Image thumbnail -->
                  @if (item.type === 'image') {
                    <div class="photo-img-wrap" (click)="openLightbox(imageMedia.indexOf(item))">
                      @if (item.file_link) {
                        <img [src]="item.file_link" [alt]="item.file_name || ''" loading="lazy" />
                      } @else {
                        <div class="photo-placeholder"><span class="material-icons text-stone-300 text-3xl">image</span></div>
                      }
                    </div>
                  }

                  <!-- Video thumbnail -->
                  @if (item.type === 'video') {
                    <div class="photo-img-wrap relative cursor-pointer" (click)="item.video_link && openVideo(item.video_link)">
                      @if (item.video_link && videoThumbnail(item.video_link)) {
                        <img [src]="videoThumbnail(item.video_link)!" alt="" loading="lazy" class="w-full h-full object-cover" />
                      } @else {
                        <div class="photo-placeholder bg-stone-900">
                          <span class="material-icons text-stone-500 text-3xl">videocam</span>
                        </div>
                      }
                      <!-- Play overlay -->
                      <div class="absolute inset-0 flex items-center justify-center pointer-events-none">
                        <div class="w-8 h-8 rounded-full bg-black/60 flex items-center justify-center">
                          <svg class="w-4 h-4 text-white ml-0.5" fill="currentColor" viewBox="0 0 24 24">
                            <path d="M8 5v14l11-7z"/>
                          </svg>
                        </div>
                      </div>
                    </div>
                  }

                  @if (item.is_main) {
                    <div class="photo-main-badge">
                      <span class="material-icons text-[11px]">star</span>
                      Principal
                    </div>
                  }
                  @if (isEditMode() && permService.can('marketing', 'albums', 'manage_media')) {
                    <div class="photo-actions">
                      @if (!item.is_main) {
                        <button (click)="setMainMedia(item.id)" title="Définir comme principal"
                          class="photo-action-btn photo-btn-star">
                          <span class="material-icons text-[14px]">star_outline</span>
                        </button>
                      }
                      <button (click)="clearMedia(item.id)" title="Retirer"
                        class="photo-action-btn photo-btn-delete">
                        <span class="material-icons text-[14px]">clear</span>
                      </button>
                    </div>
                  }
                </div>
              }

              <!-- Pending photo previews (edit mode only) -->
              @if (isEditMode()) { @for (preview of pendingPreviews(); track $index; let pi = $index) {
                <div class="photo-cell photo-pending">
                  <div class="photo-img-wrap">
                    <img [src]="preview" alt="" />
                  </div>
                  <div class="photo-pending-badge">En attente</div>
                  <div class="photo-actions">
                    <button (click)="removePending(pi)" title="Retirer"
                      class="photo-action-btn photo-btn-delete">
                      <span class="material-icons text-[14px]">close</span>
                    </button>
                  </div>
                </div>
              } }

              <!-- Pending video links (edit mode only) -->
              @if (isEditMode()) { @for (link of pendingVideoLinks(); track $index; let vi = $index) {
                <div class="photo-cell photo-pending">
                  <div class="photo-img-wrap relative bg-stone-900">
                    @if (videoThumbnail(link)) {
                      <img [src]="videoThumbnail(link)!" alt="" class="w-full h-full object-cover opacity-70" />
                    } @else {
                      <div class="w-full h-full flex items-center justify-center">
                        <span class="material-icons text-stone-500 text-3xl">videocam</span>
                      </div>
                    }
                    <div class="absolute inset-0 flex items-center justify-center pointer-events-none">
                      <div class="w-7 h-7 rounded-full bg-black/60 flex items-center justify-center">
                        <svg class="w-3.5 h-3.5 text-white ml-0.5" fill="currentColor" viewBox="0 0 24 24"><path d="M8 5v14l11-7z"/></svg>
                      </div>
                    </div>
                  </div>
                  <div class="photo-pending-badge">En attente</div>
                  <div class="photo-actions">
                    <button (click)="removePendingVideo(vi)" title="Retirer" class="photo-action-btn photo-btn-delete">
                      <span class="material-icons text-[14px]">close</span>
                    </button>
                  </div>
                </div>
              } }

              <!-- Add media button (edit mode only) -->
              @if (isEditMode() && permService.can('marketing', 'albums', 'manage_media')) {
                <div class="photo-add-cell cursor-pointer" (click)="openModal()">
                  <svg class="w-8 h-8 text-stone-300" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15"/>
                  </svg>
                  <span class="text-xs text-stone-400 font-medium mt-1">Ajouter</span>
                </div>
              }

            </div>
          </div>


        </div>

        <!-- Save button (edit mode only) -->
        @if (isEditMode() && permService.can('marketing', 'albums', 'edit')) {
          <div class="flex justify-end">
            <button (click)="saveChanges()" [disabled]="isSaving() || !editTitle().trim()"
              class="inline-flex items-center gap-2 px-6 py-2.5 bg-primary-600 text-white text-sm font-semibold rounded-xl hover:bg-primary-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors shadow-sm shadow-primary-600/10">
              @if (isSaving()) {
                <div class="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
              } @else {
                <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5"/>
                </svg>
              }
              {{ isSaving() ? 'Enregistrement…' : 'Enregistrer' }}
            </button>
          </div>
        }

      }
    </div>
  </div>
}

<!-- Add Média Modal -->
@if (showModal()) {
  <div class="fixed inset-0 z-50 flex items-center justify-center p-4" style="background:rgba(0,0,0,0.4);" (click)="closeModal()">
    <div class="bg-white rounded-2xl shadow-xl w-full max-w-md" (click)="$event.stopPropagation()">
      <div class="flex items-center justify-between px-6 pt-5 pb-4 border-b border-stone-100">
        <h2 class="text-sm font-bold text-stone-800">Ajouter un média</h2>
        <button type="button" (click)="closeModal()" class="w-7 h-7 rounded-lg hover:bg-stone-100 flex items-center justify-center text-stone-400 transition-colors">
          <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 24 24"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg>
        </button>
      </div>
      <div class="flex border-b border-stone-100 px-6">
        <button type="button" (click)="modalTab.set('image')"
          class="py-3 px-4 text-xs font-semibold border-b-2 transition-colors"
          [class]="modalTab() === 'image' ? 'border-primary-600 text-primary-600' : 'border-transparent text-stone-400 hover:text-stone-600'">
          <span class="flex items-center gap-1.5"><span class="material-icons text-sm">image</span>Image</span>
        </button>
        <button type="button" (click)="modalTab.set('video')"
          class="py-3 px-4 text-xs font-semibold border-b-2 transition-colors"
          [class]="modalTab() === 'video' ? 'border-primary-600 text-primary-600' : 'border-transparent text-stone-400 hover:text-stone-600'">
          <span class="flex items-center gap-1.5">
            <svg class="w-3.5 h-3.5 text-red-500" fill="currentColor" viewBox="0 0 24 24"><path d="M21.582 6.186a2.506 2.506 0 00-1.765-1.77C18.254 4 12 4 12 4s-6.254 0-7.817.416A2.506 2.506 0 002.418 6.186 26.5 26.5 0 002 12a26.5 26.5 0 00.418 5.814 2.506 2.506 0 001.765 1.77C5.746 20 12 20 12 20s6.254 0 7.817-.416a2.506 2.506 0 001.765-1.77A26.5 26.5 0 0022 12a26.5 26.5 0 00-.418-5.814zM10 15.464V8.536L16 12l-6 3.464z"/></svg>
            Vidéo
          </span>
        </button>
      </div>
      <div class="px-6 py-5 space-y-4">
        @if (modalTab() === 'image') {
          @if (modalFiles().length > 0) {
            <div class="grid grid-cols-3 gap-2 max-h-64 overflow-y-auto">
              @for (f of modalFiles(); track $index) {
                <div class="relative aspect-square rounded-xl overflow-hidden bg-stone-100">
                  @if (f.preview) {
                    <img [src]="f.preview" alt="" class="w-full h-full object-cover" />
                  }
                  <button type="button" (click)="removeModalFile($index)"
                    class="absolute top-1 right-1 w-5 h-5 rounded-full bg-red-500 text-white flex items-center justify-center shadow">
                    <svg class="w-3 h-3" fill="currentColor" viewBox="0 0 24 24"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg>
                  </button>
                </div>
              }
            </div>
            <p class="text-xs text-stone-500">{{ modalFiles().length }} image{{ modalFiles().length > 1 ? 's' : '' }} sélectionnée{{ modalFiles().length > 1 ? 's' : '' }}</p>
          }
          <label class="cursor-pointer flex flex-col items-center justify-center gap-2 rounded-xl border-2 border-dashed border-stone-300 hover:border-primary-400 transition-colors"
            [class]="modalFiles().length ? 'py-4' : 'py-10'">
            <span class="material-icons text-stone-300 text-4xl">add_photo_alternate</span>
            <span class="text-sm text-stone-400">
              @if (modalFiles().length) { Ajouter d'autres images } @else { Cliquez pour sélectionner une ou plusieurs images }
            </span>
            <span class="text-xs text-stone-300">JPG, WEBP · max 10 Mo par image</span>
            <input type="file" accept=".jpg,.jpeg,.webp" multiple class="hidden" (change)="onModalFileSelected($event)" />
          </label>
        }
        @if (modalTab() === 'video') {
          <div class="space-y-2">
            <label class="text-xs font-semibold text-stone-500">Lien YouTube ou Vimeo</label>
            <input type="url"
              [value]="modalVideoLink()"
              (input)="modalVideoLink.set($any($event.target).value)"
              placeholder="https://www.youtube.com/watch?v=..."
              class="fiche-input w-full" />
          </div>
        }
        @if (modalError()) {
          <p class="text-xs text-red-500">{{ modalError() }}</p>
        }
      </div>
      <div class="flex items-center justify-end gap-3 px-6 pb-5">
        <button type="button" (click)="closeModal()"
          class="px-4 py-2 border border-stone-200 text-stone-600 rounded-xl hover:bg-stone-50 text-sm font-medium transition-colors">
          Annuler
        </button>
        <button type="button" (click)="confirmAdd()"
          class="px-5 py-2 bg-primary-600 text-white rounded-xl hover:bg-primary-700 text-sm font-semibold transition-colors">
          Ajouter
        </button>
      </div>
    </div>
  </div>
}

<!-- Video modal -->
@if (activeVideoUrl()) {
  <div class="fixed inset-0 z-50 flex items-center justify-center p-4" style="background:rgba(0,0,0,0.85);" (click)="closeVideo()">
    <button class="absolute top-4 right-4 w-9 h-9 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center text-white transition-colors" (click)="closeVideo()">
      <svg class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"/>
      </svg>
    </button>
    <div class="w-full max-w-4xl rounded-2xl overflow-hidden bg-black shadow-2xl" style="aspect-ratio:16/9;" (click)="$event.stopPropagation()">
      <iframe [src]="activeVideoUrl()!" class="w-full h-full border-0" allowfullscreen
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"></iframe>
    </div>
  </div>
}

<!-- Lightbox -->
@if (lightboxIndex() >= 0 && lightboxPhoto) {
  <div class="lightbox-backdrop" (click)="closeLightbox()">
    <button class="lightbox-close" (click)="closeLightbox()">
      <svg class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"/>
      </svg>
    </button>
    <div class="lightbox-counter">{{ lightboxIndex() + 1 }} / {{ imageMedia.length }}</div>
    @if (imageMedia.length > 1) {
      <button class="lightbox-nav lightbox-nav-prev" (click)="$event.stopPropagation(); prevPhoto()">
        <svg class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
          <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7"/>
        </svg>
      </button>
    }
    <div class="lightbox-img-wrap" (click)="$event.stopPropagation()">
      <img [src]="lightboxPhoto" alt="" class="lightbox-img" />
    </div>
    @if (imageMedia.length > 1) {
      <button class="lightbox-nav lightbox-nav-next" (click)="$event.stopPropagation(); nextPhoto()">
        <svg class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
          <path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7"/>
        </svg>
      </button>
    }
    @if (imageMedia.length > 1) {
      <div class="lightbox-strip" (click)="$event.stopPropagation()">
        @for (photo of imageMedia; track photo.id; let i = $index) {
          <div class="lightbox-thumb" [class.active]="i === lightboxIndex()" (click)="openLightbox(i)">
            @if (photo.file_link) { <img [src]="photo.file_link" alt="" class="w-full h-full object-cover" /> }
          </div>
        }
      </div>
    }
  </div>
}
